import { connect } from 'react-redux';
import {
	queryCompanyPointsLogData,
	withGetCompanyPointsData,
} from 'src/_shared/api/components/points/';
import { dashboardActions, userActions } from 'src/actions.js';
import { compose } from '../_shared/services/utils';
import PointsComponent from './PointsComponent.jsx';

const mapStateToProperties = (state) => {
	const { allMultiLingualData } = state.dashboard;
	return {
		currentUser: state.user.currentUser,
		allMultiLingualData,
	};
};

const mapDispatchToProperties = (dispatch) => {
	return {
		updateCurrentUser(values) {
			dispatch(userActions.updateCurrentUser(values));
		},
		setMultiLingualData(data) {
			dispatch(dashboardActions.createSetMultiLingualData(data));
		},
	};
};

export const PointWithpi = compose(
	withGetCompanyPointsData,
	queryCompanyPointsLogData
)(PointsComponent);
export const Points = connect(
	mapStateToProperties,
	mapDispatchToProperties
)(PointWithpi);
